import { createAsyncThunk, AsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { SERVICES, HttpMethods } from '../../services/api';
import { showSuccessMessage } from '../notifications';

export interface IApiCredentialsDTO {
  accountId: string;
  recipientsEmails: string[];
  rsaKey: string;
  filename: string;
}

export const createApiCredentials: AsyncThunk<void, IApiCredentialsDTO, ThunkAPI> = createAsyncThunk(
  'apiCredentials',
  async (keyData: IApiCredentialsDTO, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IApiCredentialsDTO>({
        endpoint: 'apiCredentials',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(keyData, thunk);
      thunk.dispatch(showSuccessMessage('Email with instructions has been sent'));
      return response;
    } catch(err) {
      return thunk.rejectWithValue(err || 'An error occurred create apiCredentials ');
    }
  }
);

export const editApiCredentials: AsyncThunk<void, IApiCredentialsDTO, ThunkAPI> = createAsyncThunk(
  'apiCredentials',
  async (keyData: IApiCredentialsDTO, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IApiCredentialsDTO>({
        endpoint: 'apiCredentials',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Patch,
        contentType: 'application/json'
      })(keyData, thunk);
      thunk.dispatch(showSuccessMessage('Email with instructions has been sent'));
      return response;
    } catch(err) {
      return thunk.rejectWithValue(err || 'An error occurred updating apiCredentials ');
    }
  }
);